import styled from 'styled-components';

import Typography from '@common/components/Typography';

const PageLeadDescription = styled(Typography).attrs({
  variant: 'subtitle2',
})`
  font-weight: 400;
  ${({ theme, noSpacing }) =>
    noSpacing ? 0 : theme.getFluidSpacing('margin-bottom', 'section', 2)};
`;

export default PageLeadDescription;
